import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import CountertopsHero from './components/CountertopsHero';
import CountertopsServices from './components/CountertopsServices';
import MaterialsShowcase from './components/MaterialsShowcase';
import ContractorDirectory from './components/ContractorDirectory';
import ComparisonChecklist from './components/ComparisonChecklist';
import CountertopsFAQ from './components/CountertopsFAQ';

export default function CountertopsPage() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Header />
      <main>
        <CountertopsHero />
        <CountertopsServices />
        <MaterialsShowcase />
        <ContractorDirectory />
        <ComparisonChecklist />
        <CountertopsFAQ />
      </main>
      <Footer />
    </div>
  );
}
